import React, { useState, useRef } from 'react';
import Modal from '@cloudscape-design/components/modal';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import PDFRedactionDetector from './detect-redacted-pages';
import redactIcon from '../assets/redactIcon.png';
import { addUsage } from './add-usage.js';

const RedactionDetection = () => {
  const [visible, setVisible] = useState(false);
  const [serviceName] = useState('PDF Falsified Detector');
  const detectorRef = useRef();

  const toggleModal = React.useCallback(() => {
    setVisible(true);
  }, []);

  const handleClose = () => {
    // Reset the detector when modal is closed
    if (detectorRef.current) {
      detectorRef.current.resetAnalysis();
    }
    setVisible(false);
    addUsage('AWESOME PDF TOOLS RedactionDetection', '1.0', 1, window.location.href);
  };

  const handleModalDismiss = () => {
    // Reset the detector when modal is dismissed (clicking outside or X button)
    if (detectorRef.current) {
      detectorRef.current.resetAnalysis();
    }
    setVisible(false);
    addUsage('AWESOME PDF TOOLS RedactionDetection', '1.0', 1, window.location.href);
  };

  return (
    <div>
      <div className="service-card" onClick={toggleModal}>
        <div className="service-card-icon">
          <img src={redactIcon} alt="PDF Falsified Detector" loading="lazy" />
        </div>
        <h3 className="service-card-title">PDF Falsified Detector</h3>
        <p className="service-card-desc">Detect redacted or falsified content in PDF documents</p>
        <div className="service-card-action">
          <span>Get Started</span>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
          </svg>
        </div>
      </div>

      <Modal
        onDismiss={handleModalDismiss}
        visible={visible}
        size="large"
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={handleClose}>
                Close
              </Button>
            </SpaceBetween>
          </Box>
        }
        header={serviceName}
      >
        <PDFRedactionDetector ref={detectorRef} />
      </Modal>
    </div>
  );
};

export default RedactionDetection;
